/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconStack = createReactComponent("stack", "IconStack", [
  ["path", { d: "M12 6l-8 4l8 4l8 -4l-8 -4", key: "svg-0" }],
  ["path", { d: "M4 14l8 4l8 -4", key: "svg-1" }]
]);

export { IconStack as default };
//# sourceMappingURL=IconStack.js.map
